"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BlogSettingsPageContainer = _interopRequireDefault(require("../BlogSettingsPageContainer"));

var _AsyncCommentsSettings = _interopRequireDefault(require("./AsyncCommentsSettings"));

var _default = function _default() {
  return _react.default.createElement(_BlogSettingsPageContainer.default, null, _react.default.createElement(_AsyncCommentsSettings.default, null));
};

exports.default = _default;
module.exports = exports.default;